import { motion } from "framer-motion";

const tools = [
    { name: "Clay", tag: "Enrichment" },
    { name: "LeadMagic", tag: "Waterfall" },
    { name: "RB2B", tag: "Deanon" },
    { name: "Instantly", tag: "Sequencer" },
    { name: "Origami", tag: "CRM" },
    { name: "Meta Ads", tag: "Inbound" },
    { name: "Google Tags", tag: "Intent" },
];

export default function ToolStack() {
    return (
        <section
            data-testid="tool-stack-section"
            className="container-x py-20 md:py-28 rule-bottom"
        >
            <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-10">
                <span className="tag">The Stack</span>
                <p className="font-editorial italic text-white/60 text-lg md:text-xl max-w-[38ch] md:text-right">
                    Not apps in a stack. Components of a closed loop.
                </p>
            </div>
            <ul className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-7 border-y border-white/10 divide-x divide-white/5">
                {tools.map((t, i) => (
                    <motion.li
                        key={t.name}
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ delay: i * 0.06 }}
                        className="py-8 px-4 flex flex-col items-center justify-center gap-2 group hover:bg-white/[0.02] transition-colors"
                        data-testid={`tool-${t.name.toLowerCase().replace(/\s/g, "-")}`}
                    >
                        <span className="font-display uppercase text-white text-xl md:text-2xl group-hover:text-[#e84125] transition-colors">
                            {t.name}
                        </span>
                        <span className="font-mono uppercase text-[0.62rem] tracking-[0.22em] text-white/40">
                            {t.tag}
                        </span>
                    </motion.li>
                ))}
            </ul>
        </section>
    );
}
